import { TagsList } from "@components/Listings/ListingsFilter/components/ListingsFilterCheckboxList"
import { useMemo } from "react"
import { useFilterStore } from "@components/Listings/ListingsFilter/store"
import { useFilterData } from "@components/Listings/ListingsFilter/FilterDataContextProvider"
import { getMonthNum } from "@utils/index"

export function TagsUseMonth() {
    const onTagListChange = useFilterStore((s) => s.onTagListChange)
    const selectedItems = useFilterStore((s) => s.use_month_in)
    const filterData = useFilterData()
    const items = useMemo(() => {
        const use_month = (filterData?.listingFilter?.use_month?.split(",") || []).map((i) => ({ key: i }))

        return use_month.sort((a, b) => getMonthNum(a.key) - getMonthNum(b.key))
    }, [filterData])

    return <TagsList selectedItems={selectedItems} items={items} onItemChange={onTagListChange("use_month")} title="Use Year" />
}
